import axios from 'axios';
import { SUBSCRIBE_API_URL, UNSUBSCRIBE_API_URL, SUBSCRIBER_API_URL } from '../../constants/urls';
/* eslint-disable no-unused-vars */

const state = {
    success: false,
    successConfirm: false,
    resultTxt: 'Произошла ошибка соединения',
};

const actions = {
    subscribe({ commit }, data) {
        const host = this.state.context.host;

        axios.post(host + SUBSCRIBER_API_URL, data)
          .then((result) => {
              commit('subscribe', true);
          })
          .catch((error) => {
              commit('subscribe', false);
          });
    },

    confirm({ commit }, data) {
        const context = data.context;
        const params = {
            token: data.token,
        };
        const host = this.state.context.host;

        let action = null;
        if (context === 'activate') {
            action = SUBSCRIBE_API_URL;
        } else if (context === 'deactivate') {
            action = UNSUBSCRIBE_API_URL;
        }

        axios.post(host + action, data)
            .then((result) => {
                if (result.status !== 200) {
                    commit('successConfirm', false);
                } else {
                    commit('successConfirm', true);
                    commit('resultTxt', result.data.detail);
                }
            })
            .catch((error) => {
                commit('successConfirm', false);
                commit('resultTxt', error.data.detail);
            });
    },
};

const mutations = {
    subscribe(state, value) {
        state.success = value;
    },

    successConfirm(state, value) {
        state.successConfirm = value;
    },

    resultTxt(state, value) {
        state.resultTxt = value;
    },
};

const getters = {
    success({ success }) {
        return success;
    },

    successConfirm({ successConfirm }) {
        return successConfirm;
    },

    resultTxt({ resultTxt }) {
        return resultTxt;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/subscribes.js